export enum TypesEnum {
  ACCOUNT_NOTIFICATIONS = 'accountNotification',
  SYSTEM_UPDATE = 'systemUpdate',
  RESPONSE = 'response',
  WHATS_NEW = 'whatsNew',
  DOWNLOADS = 'downloads',
  UPLOADS = 'uploads',
}

export const typesIds = {
  [TypesEnum.ACCOUNT_NOTIFICATIONS]: 'account_notification',
  [TypesEnum.SYSTEM_UPDATE]: 'system_update',
  [TypesEnum.RESPONSE]: 'response',
  [TypesEnum.WHATS_NEW]: 'whats_new',
  [TypesEnum.DOWNLOADS]: 'downloads',
  [TypesEnum.UPLOADS]: 'uploads',
};

export const types = {
  [TypesEnum.ACCOUNT_NOTIFICATIONS]: {
    id: typesIds.accountNotification,
    label: 'NOTIFICATIONS_CENTRE.TYPES.ACCOUNT_NOTIFICATION',
  },
  [TypesEnum.SYSTEM_UPDATE]: {
    id: typesIds.systemUpdate,
    label: 'NOTIFICATIONS_CENTRE.TYPES.SYSTEM_UPDATE',
  },
  [TypesEnum.RESPONSE]: {
    id: typesIds.response,
    label: 'NOTIFICATIONS_CENTRE.TYPES.RESPONSE',
  },
  [TypesEnum.WHATS_NEW]: {
    id: typesIds.whatsNew,
    label: 'NOTIFICATIONS_CENTRE.TYPES.WHATS_NEW',
  },
  [TypesEnum.DOWNLOADS]: {
    id: typesIds.downloads,
    label: 'NOTIFICATIONS_CENTRE.TYPES.DOWNLOADS',
  },
  [TypesEnum.UPLOADS]: {
    id: typesIds.uploads,
    label: 'NOTIFICATIONS_CENTRE.TYPES.UPLOADS',
  },
};
